import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';
import { useCallback, useState } from 'react';
import { createChangePasswordOutbound } from '../../api/outbound/commonOutbounds';
import { useInstanceId } from '../../context/instance/instanceContext';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { thunkCloseCurrentMessageBox } from '../../redux/actions/messageBoxesActions';
import { addToast, thunkCloseToast } from '../../redux/actions/toastsActions';
import { useAppDispatch } from '../../redux/store';
import { CHANGE_PASSWORD_TOAST_KEY } from '../../types/toastTypes';
import { FormControlContainer } from '../formControlContainer';
import { OpenModalContainer } from '../openModalContainer';
import { PasswordRequirementsDetails } from '../passwordRequirementsDetails';
import { GoToAccountModalHeaderButton } from './goToAccountModalHeaderButton';
export const ChangePasswordModal = ({ title, onClose }) => {
    const dispatch = useAppDispatch();
    const instanceId = useInstanceId();
    const socketSend = useSocketSend();
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [newPasswordConfirmation, setNewPasswordConfirmation] = useState('');
    const onClickUpdate = useCallback(() => {
        dispatch(thunkCloseToast(CHANGE_PASSWORD_TOAST_KEY));
        if (!currentPassword) {
            dispatch(addToast({
                type: 'change-password-error',
                key: CHANGE_PASSWORD_TOAST_KEY,
                message: 'Your current password is required.'
            }));
            return;
        }
        if (!newPassword) {
            dispatch(addToast({
                type: 'change-password-error',
                key: CHANGE_PASSWORD_TOAST_KEY,
                message: 'Enter a new password.'
            }));
            return;
        }
        if (newPassword !== newPasswordConfirmation) {
            dispatch(addToast({
                type: 'change-password-error',
                key: CHANGE_PASSWORD_TOAST_KEY,
                message: 'Your password confirmation does not match.'
            }));
            return;
        }
        // If we get here, all is OK as far as the client side is concerned.
        socketSend(createChangePasswordOutbound(currentPassword, newPassword));
        dispatch(thunkCloseCurrentMessageBox());
    }, [currentPassword, dispatch, newPassword, newPasswordConfirmation, socketSend]);
    const onChangeCurrentPassword = (event) => {
        setCurrentPassword(event.target.value);
    };
    const onChangeNewPassword = (event) => {
        setNewPassword(event.target.value);
    };
    const onChangeNewPasswordConfirmation = (event) => {
        setNewPasswordConfirmation(event.target.value);
    };
    return (_jsx(OpenModalContainer, { title: title, onClose: onClose, maxWidth: 'md', additionalControls: _jsx(GoToAccountModalHeaderButton, { onClose: onClose }), children: _jsx(DialogContent, { children: _jsxs(DialogContentText, { component: 'div', children: [_jsx(FormControlContainer, { children: _jsx(TextField, { id: `change-password-current-${instanceId}`, type: 'password', variant: 'filled', fullWidth: true, label: 'Current Password', value: currentPassword, onChange: onChangeCurrentPassword }) }), _jsxs(FormControlContainer, { children: [_jsx(TextField, { id: `change-password-new-${instanceId}`, type: 'password', variant: 'filled', fullWidth: true, label: 'New Password', value: newPassword, onChange: onChangeNewPassword }), _jsx(TextField, { id: `change-password-confirm-${instanceId}`, type: 'password', variant: 'filled', fullWidth: true, label: 'Confirm New Password', value: newPasswordConfirmation, onChange: onChangeNewPasswordConfirmation })] }), _jsx(PasswordRequirementsDetails, {}), _jsx(DialogActions, { children: _jsx(Button, { variant: 'contained', color: 'secondary', onClick: onClickUpdate, children: "Update Password" }) })] }) }) }));
};
